<div class="mb-[30px]">
  <div class="mb-3 font-bold">
    {{ 'notification-form.title' | translate }}
  </div>
  <div class="relative flex items-center w-full">
    <input
      [formControl]="titleControl"
      class="pr-[62px]"
      placeholder="{{ 'notification-form.title-placeholder' | translate }}"
      (input)="removeEmojis($event)"
      maxlength="50"
      [ngClass]="{
        'alert-border message-alert-textarea':
          titleControl.value?.length < 3 &&
          titleControl.value?.length > 0 &&
          titleControl.touched,
        'alert-text': titleControl.value?.length > 50
      }"
    />
    <!-- counter -->
    <span
      class="opacity-70 text-xs absolute right-4"
      [ngClass]="{
        'alert-text': titleControl.value?.length > 50
      }"
    >
      {{ titleControl.value?.length || 0 }} / 50
    </span>
  </div>

  <div class="relative">
    <!-- error message -->
    <div
      class="form-alert alert-text absolute top-1"
      [ngClass]="{
        'show-form-alert':
          titleControl.value?.length < 3 &&
          titleControl.value?.length > 0 &&
          titleControl.touched
      }"
    >
      <fa-icon [icon]="'warning'"></fa-icon>
      {{ 'notification-form.title-error' | translate }}
    </div>
  </div>
</div>
